<script>
import { _request } from '@/helpers/_request.js'
import Parser from '@/helpers/_responseParser'
import axios from 'axios'
import applicationConstants from '@/constants/ApplicationConstants'

export default {
  name: 'BankService',
  methods: {
    getBankList (RemittanceOptionId) {
      return _request('GetBankList', { RemittanceOptionId }).then(Parser.toXml.bind(null, 'GetBankListResponse'))
    },
    getCashPickupList () {
      return _request('GetRemittanceoptions2').then(Parser.toXml.bind(null, 'GetRemittanceOptionsResponse2'))
    },
    getBankAccounts () {
      return _request('GetBankAccounts').then(Parser.toXml.bind(null, 'GetBankAccountsResponse'))
    },
    changeBankAccount (data, OperationType) {
      return _request('ChangeBankAccounts', { OperationType, BankAccounts: { ...data } }).then(Parser.toXml.bind(null, 'ChangeBankAccountsResponse'))
    },
    flinksAuthorize (LoginId, RequestId, accountId, Institution) {
      const _data = {
        LoginId,
        MostRecentCached: true,
        withTransactions: false
      }
      return axios.post(
        applicationConstants.flinksAPIBaseUrl + '/BankingServices/Authorize',
        _data,
        {
          crossdomain: true,
          headers: {
            Accept: '*/*',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          }
        }
      )
    },
    flinksGetAccountsDetailAsync (RequestId) {
      const _data = {
        requestId: RequestId
      }
      return axios.post(
        applicationConstants.flinksPUblicServerBaseUrl + 'getAccountsDetailAsync/',
        _data,
        {
          crossdomain: true,
          headers: {
            Accept: '*/*',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          },
          auth: {
            username: 'secret',
            password: 'secret'
          }
        }
      )
    },
    flinksRefreshAccountsDetail (RequestId, accountId, LoginId, Institution) {
      const _data = {
        RequestId,
        accountsFilter: [accountId]
      }
      return axios.post(
        applicationConstants.flinksAPIBaseUrl + 'BankingServices/GetAccountsDetail/',
        _data,
        {
          crossdomain: true,
          headers: {
            Accept: '*/*',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          }
        }
      )
    },
    flinksGetBankDetails (accountId, loginId) {
      const _data = {
        LoginId: loginId,
        accountsFilter: [accountId]
      }
      return axios.post(
        applicationConstants.flinksPUblicServerBaseUrl + 'getAccountsDetail',
        _data,
        {
          headers: {
            'Content-Type': 'application/json'
          },
          auth: {
            username: 'secret',
            password: 'secret'
          }
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/services/BankService.vue